import { initializeVue } from "@/core/app-setup";
import ConversationView from "@/experiences/conversation-response/views/ConversationView.vue";
window.initializeConversationResponse = (elSelector, rootProps) => {
    return initializeVue(elSelector, ConversationView, { rootProps });
};
